import { AlertCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

import { IntegrationV2Properties, ConnectionStatusV2 } from '@/gql/graphql';
export const TrackingDiagramIntegrationsErrorMessage = ({
  destinations
}: {
  destinations: IntegrationV2Properties[] | undefined;
}) => {
  if (!destinations) {
    return null;
  }

  const hasDisconnectedIntegrations = destinations.some(
    (destination) => destination.status === ConnectionStatusV2.Error
  );

  if (!hasDisconnectedIntegrations) {
    return null;
  }

  return (
    <div className="flex flex-col gap-1 border border-red-500 p-4 mt-16 rounded-lg">
      <div className="flex items-center gap-2">
        <AlertCircle className="h-4 w-4 text-destructive-foreground" />
        <h1 className="text-base font-medium text-destructive-foreground">
          Integrations Disconnected
        </h1>
      </div>
      <p className="text-sm text-destructive-foreground pl-6">
        One or more of your integrations are currently disconnected due to invalid or expired
        credentials. This may prevent some messages or automations from being delivered.
      </p>
      <p className="text-sm text-destructive-foreground pl-6 mb-3">
        Please review and update your disconnected integrations to restore functionality.
      </p>
      <div className="flex items-center pl-6">
        <Button variant="destructive" size="sm" className="py-0 px-2 text-xs" asChild>
          <Link to="./?screen=error">View Disconnected Integrations</Link>
        </Button>
      </div>
    </div>
  );
};
